import { Backdrop, CircularProgress, Stack } from "@mui/material";
import { useAppSelector } from "hooks/StoreHooks";

interface Props {
  children: React.ReactElement;
}

export default function Loading(props: Props) {
  const loadingRequests = useAppSelector(
    state => state.appState.loadingRequests
  );

  return (
    <Stack
      className="loading"
      sx={{
        width: "100%", height: "100%"
      }}>
      {props.children}
      {loadingRequests.length !== 0 && (
      <Backdrop
        sx={{ color: "#fff", zIndex: 2147483647 }}
        open={loadingRequests.length !== 0}>
        <CircularProgress color="inherit" />
      </Backdrop>)}
    </Stack>
  );
}
